<template>
	<div class="c-picker">
		<c-scroll ref="scroll" :scroll-bar="false" :style="{'height': toothCount * itemHeight + 'px'}" @start="startHandle" @end="endHandle">
			<div>
				<div :style="{'height': (toothCount- 1) / 2 * itemHeight + 'px'}"></div>
				<ul :style="{'padding-right': text ? `calc(.2rem + ${text.length}em)` : 0}">
					<li v-for="(item, i) in list" :key="i" class="flex-center">{{item}}</li>
				</ul>
				<div :style="{'height': (toothCount- 1) / 2 * itemHeight + 'px'}"></div>
			</div>
		</c-scroll>
		<div v-if="text" class="c-picker-line flex-end-center">
			<p>{{text}}</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'cGear',
		
		props: {
			value: {
				type: [String, Number],
				default: 0
			},
			list: Array,
			text: String,
			toothCount: {
				type: [String, Number],
				default: 5
			}
		},

		data() {
			return {
				current: this.value,
				itemHeight: 40
			}
		},
		
		watch: {
			value(val) {
				this.current = val;
			},

			current(val) {
				clearTimeout(this._timer);
				this.set(val, this._manual ? 500 : 0);
				this._manual = false;
				this.$emit('input', val);
			}
		},

		methods: {
			set(val, time = 0) {
				this.$refs.scroll._scroll.refresh();
				this.current = val;
				this.$refs.scroll.scrollTo(val * this.itemHeight, time);
			},

			get() {
				return this.current;
			},

			startHandle() {
				this._start = true;
				clearTimeout(this._timer);
			},

			endHandle(e) {
				if (!this._start) return;
				this._start = false;
				clearTimeout(this._timer);
				this._manual = true;
				this.current = parseInt((e.y / this.itemHeight).toFixed(0));
				this._timer = setTimeout(() => {
					this.$refs.scroll.scrollTo(this.current * this.itemHeight);
				}, 100);
				this.$emit('change', this.current);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	$itemHeight = 40px;

	.c-picker {
		position: relative;

		&:before {
			content: '';
			z-index: 1;
			position: absolute;
			left: 0;
			top: 0;
			right: 0;
			height: $itemHeight;
			background: linear-gradient(to bottom, #fff, rgba(255,255,255,.5));
			pointer-events: none;
		}

		&:after {
			content: '';
			z-index: 1;
			position: absolute;
			left: 0;
			bottom: 0;
			right: 0;
			height: $itemHeight;
			background: linear-gradient(to top, #fff, rgba(255,255,255,.6));
			pointer-events: none;
		}

		li {
			height: $itemHeight;
			font-size: .26rem;
		}

		&-line {
			z-index: 1;
			position: absolute;
			left: 0;
			right: 0;
			top: 50%;
			box-sizing: border-box;
			height: $itemHeight;
			border: 1px solid #ddd;
			border-width: 1px 0;
			transform: translate(0,-50%);
			pointer-events: none;

			p {
				padding-right: .2rem;
				font-size: .26rem;
				text-align: center;
			}
		}
	}
</style>
